import React from 'react';
import { useTranslation } from 'react-i18next';
import '../../../style/scss/live-edit.scss';
import '../../../style/scss/forms.scss';

interface TextInputProps {
    name: string;
    placeholder: string;
    value: string | null;
    errorMessage?: string | undefined;
    shouldAutoFocus?: boolean;
    disabled?: boolean;
    isInvalid?: boolean;
    allow1Password?: boolean;
    onChange: (value: string) => void;
    onBlur?: (value: string) => void;
}

const TextInput: React.FC<TextInputProps> = ({
    name, placeholder, value, errorMessage, shouldAutoFocus,
    disabled = false, isInvalid, allow1Password, onChange, onBlur
}) => {
    const { t } = useTranslation();

    return (
        <input
            type="text"
            id={name}
            name={name}
            placeholder={t(placeholder)}
            value={value ?? ''}
            disabled={disabled}
            onChange={(e) => onChange(e.target.value)}
            onBlur={(e) => {if (onBlur) onBlur(e.target.value)}}
            className={`text ${(errorMessage || isInvalid) ? 'is-invalid' : ''}`}
            autoFocus={shouldAutoFocus}
            {...(!allow1Password && { 'data-1p-ignore': 'true' })}
        />
    )
};

export default TextInput;